<template>
    <div class="next SubAgentReport">
        <div class="title">
            <span> {{$t('my.proxy.SubAgentReport')}} </span>
            <div class="fixed" @click="gaBack">
                <svg t="1658129167849" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="12456" width="0.3rem" height="0.3rem">
                    <path
                        d="M245.01248 555.52512l447.0784 447.0784c22.42048 22.42048 58.81856 22.42048 81.31584 0 22.42048-22.42048 22.42048-58.81856 0-81.31584l-406.49216-406.4256 406.49728-406.49216c22.42048-22.42048 22.42048-58.81856 0-81.31584-22.42048-22.42048-58.81856-22.42048-81.31584 0L244.9408 474.20928c-22.43584 22.47168-22.40512 58.88 0.07168 81.31584 0-0.00512 0 0 0 0z"
                        fill="#666666" p-id="12457"></path>
                </svg>
            </div>
            <div class="title_ellipsis">
                <img @click="topsearchBox=!topsearchBox" src="../../../assets/img/topSearch.png" />
            </div>

            <div v-show="topsearchBox" class="searchBox">
                <div class="tips">{{ $t('my.proxy.searchTips') }}</div>
                <van-cell-group inset>
                    <van-field v-model.trim="value" @keyup="value=value.replace(/[^\d]/g,'')" :placeholder="`${$t('my.proxy.agentIDTips')}`" autocomplete="off" />
                </van-cell-group>

                <van-cell-group inset>
                    <van-field v-model.trim="nextMemberID"  @keyup="nextMemberID=nextMemberID.replace(/[^\d]/g,'')" :placeholder="`${$t('my.proxy.subAgentIDTips')}`" autocomplete="off" />
                </van-cell-group>

                <van-cell-group inset>
                    <van-field v-model.trim="dateShow" :right-icon="require('../../../assets/img/select.png')" readonly @click="dateClick"
                    :placeholder="`${$t('my.proxy.selectTime')}`"  />
                </van-cell-group>

                <div class="searchBtnBox flexCenter">
                    <div @click="reset" class="confirmBtn borderRound">{{$t('common.reset')}}</div>
                    <div @click="comfigSearch" class="confirmBtn hasValue">{{$t('my.proxy.filter')}}</div>
                </div>

            </div>
        </div>

        <div class="exchangeData">
            <div class="tableTitle">
                {{$t('my.proxy.subAgentReportTable.totalBelowFee')}} {{ digitalNumber(totalBelowFee) }}
            </div>
            <div class="tableItem tableHead flexBetween">
                <div>{{$t('my.proxy.subAgentReportTable.agentID')}}</div>
                <div>{{$t('my.proxy.subAgentReportTable.superiorAgent')}}</div>
                <div>{{$t('my.proxy.commission')}}</div>
                <div>{{$t('my.proxy.subAgentReportTable.commissionShare')}}</div>
            </div>
            <div v-if="tableList.length>0">
                <van-pull-refresh v-model="isLoading" :disabled="isRefreshDisable" @refresh="onRefresh">
                    <template #pulling>
                        <van-loading />
                    </template>

                    <!-- 释放提示 -->
                    <template #loosing>
                        <van-loading />
                    </template>

                    <!-- 加载提示 -->
                    <template #loading>
                        <van-loading />
                    </template>
                    <!-- finished // 是否已加载完成，加载完成后不再触发load事件
                        offset // 滚动条与底部距离小于offset时触发load事件
                        immediate-check // 是否在初始化时立即执行滚动位置检查
                        onLoad  // 滚动条与底部距离小于offset时触发onLoad()
                        :immediate-check="flase" 
                    -->
                    <van-list
                        v-model="loading"
                        :finished="finished"
                        style="height:calc(100vh - 2.1rem);overflow:scroll;"
                        :offset="10" 
                        :immediate-check="check" 
                        :finish-text="`${$t('lottery.noMore')}`"
                        @load="onLoad" 
                        >
                            <div v-for="(item, index) in tableList" :key="`${index}--tableList`" class="tableItemBox">
                                <div class="flexBetween tableItem">
                                    <div>{{item.belowUid}}</div>
                                    <div>
                                        <p>{{item.parentUid}}</p>
                                    </div>
                                    <div>
                                        <span>{{digitalNumber(item.commission)}}</span>
                                    </div>
                                    <div class="flexBetweenTop">
                                        <p>{{ digitalNumber(item.belowFee) }}</p>
                                        <van-icon v-show="!item.falg" @click="item.falg=!item.falg" name="arrow-down" />
                                        <van-icon v-show="item.falg" @click="item.falg=!item.falg" name="arrow-up" />
                                    </div>
                                </div>
                                <div v-show="item.falg" class="tableItemMore">
                                    <p>{{$t('my.proxy.subAgentReportTable.belowFeePercent')}}<span>{{ item.belowFeePercent }}%</span></p>
                                    <p>{{$t('my.proxy.subAgentReportTable.proxyLevel')}}<span>{{ item.proxyLevel }}</span></p>
                                    <p>{{$t('my.proxy.subAgentReportTable.activeNum')}}<span>{{ item.activeNum }}</span></p>
                                    <p>{{$t('my.proxy.subAgentReportTable.justifyNetWin')}}<span>{{ digitalNumber(item.justifyNetWin) }}</span></p>
                                    <p>{{$t('my.proxy.subAgentReportTable.commissionPercent')}}<span>{{ item.commissionPercent }}%</span></p>
                                    <p>{{$t('my.proxy.subAgentReportTable.accountAdjustment')}}<span>{{ digitalNumber(item.accountAdjustment) }}</span></p>
                                </div>
                            </div>
                    </van-list>
                </van-pull-refresh>
            </div>

            <div v-else class="noData">
                <img src="../../../assets/img/record/noData.png"/>
                <p>{{$t('common.noData')}}</p>
            </div>
        </div>

        <van-action-sheet class="bankModel" v-model:show="showMonth" :title="`${$t('my.proxy.selectMonth')}`">
            <div class="bankListCont">
                <div v-for="(item, index) in arrMonth" :key="`${index}--arrMonth`" @click="changeMonth(item,index)" class="bankListCont_item flexBetween">
                    <div class="bankListCont_item_left">
                        <p>{{ item }}</p>
                    </div>
                    <div v-show="actvieMonth==index">
                        <van-icon name="success" color="#f86fab" size="0.5rem"/>
                    </div>
                </div>
            </div>
        </van-action-sheet>
    </div>
</template>

<script>
import { queryProxyBelowReport, queryProxyBelowReportMonth } from "@/api/proxy";
// import utils from "@/utils/index";
export default {
    data() {
        return {
            value: "",
            nextMemberID: "",
            dateShow: "", //月份
            tableList: [],
            maxDate: new Date(),
            currentStartDate: new Date(),
            currentEndDate: new Date(),
            topsearchBox: false, //搜索条件是否展示
            rightIcon: require('../../../assets/img/select.png'), 
            arrMonth: [], //月份列表
            page: 0,
            showMonth: false,
            actvieMonth: 0,
            isLoading: false,
            isRefreshDisable: false,
            finished: false,
            check: false, //是否开始就检查
            loading: false,
            totalBelowFee: 0, //总佣金抽成
            scrollTop: 0, //滚动的距离
        }
    },
    watch: {
        scrollTop(newval) {
            if (newval > 0) {
                this.isRefreshDisable = true
            } else {
                this.isRefreshDisable = false
            }
        }
    },
    computed: {
        member() {
            return this.$store.state.member;
        },
    },
    created() {
        this.queryProxyBelowReportMonth();
    },
    methods: {
        // 时间框点击
        dateClick() {
            if (this.arrMonth.length == 0) {
                this.$toast(this.$t('common.noData'));
            } else {
                this.showMonth = true
            }
        },
        // 重置
        reset() {
            this.value = "";
            this.nextMemberID = "";
            this.dateShow = this.arrMonth[0];
            this.getList();
        },
        // onLoad 加载更多
        onLoad() {
            if (!this.finished) {
                this.loading = true;
                this.page ++;
                this.getList();
            }
        },
        onRefresh() {
            setTimeout(() => {
                this.page = 0;
                this.getList(true);
            }, 1000);
        },
        // 点击月份
        changeMonth(item, index) {
            this.actvieMonth = index;
            this.dateShow = item;
            this.showMonth = false;
        },
        //筛选 
        comfigSearch() {
            this.page = 0;
            this.getList();
        },
        gaBack() {
            this.$router.push(`/mine/myProxy`);
        },
        /**
         * @description: 下拉刷新和滚动事件冲突
         * @param {*}
         * @return {*}
         */
        resolveConflict(val) {
            const vantList = val;
            vantList.addEventListener('touchmove', () => {
                this.scrollTop = vantList.scrollTop
            });
            vantList.addEventListener('touchend', () => {
                this.scrollTop = vantList.scrollTop
            });
        },
        // 获取列表数据
        getList(refresh) {
            let params = {
                month: this.dateShow,
                parentUid: this.nextMemberID,
                belowUid: this.value,
                uid: this.member.uid,
                page: this.page,
                pageSize: 20
            }

            if (!this.page) {
                this.tableList = [];
            }
            this.loading = true;
            this.finished = true;
            queryProxyBelowReport(params).then(res => {
                if (res.code == 0) {
                    let dataArr = JSON.parse(JSON.stringify(res.data.proxyBelowReportList));
                    this.totalBelowFee = res.data.totalBelowFee;
                    dataArr.forEach(item => {
                        item.falg = false;
                    });

                    if (!params.page) {
                        this.tableList = dataArr;
                    } else {
                        if (res.data.proxyBelowReportList.length > 0) {
                        let arr = JSON.parse(JSON.stringify(this.tableList));
                        arr = [...dataArr, ...arr];
                            this.tableList = arr;
                        }
                    }

                    if (res.data.proxyBelowReportList.length == 20) {
                        this.finished = false;
                    } else {
                        this.finished = true;
                    }

                    if (refresh) {
                        this.$toast(this.$t('common.refreshSuccess'));
                    }
                    // 解决滚动条与下拉的冲突  数据没回来之前获取不到dom
                    this.$nextTick(() => {
                        const vantList = document.querySelector('.van-list');
                        if (vantList) {
                            console.log(vantList);
                            this.resolveConflict(vantList);
                        }
                    });
                } else {
                    if (res.msg) this.$toast(res.msg);
                    this.totalBelowFee = 0;
                }
                this.topsearchBox = false;
                this.loading = false;
            }).catch(err => {
                console.log(err);
                this.topsearchBox = false;
                this.loading = false;
                this.totalBelowFee = 0;
            });
        },
        // 获取月份列表
        queryProxyBelowReportMonth() {
            let params = {
                uid: this.member.uid
            }
            queryProxyBelowReportMonth(params).then(res => {
                if (res.code == 0) {
                    this.arrMonth = res.data;
                    if (res.data.length > 0) {
                        this.dateShow = res.data[0];
                        this.getList(); //获取列表的方法
                    }
                } else {
                    if (res.msg) this.$toast(res.msg);
                }
            }).catch(err => {
                console.log(err);
            });
        },
        // 选择月份
        selectMonth(item) {
            // this.queryCommissionReport(item); 列表获取方法
            this.value = item;
            this.$refs.searchItemDay.toggle();
        },
    }
}
</script>

<style lang="scss" scoped>
.SubAgentReport {
    padding-top: 1rem;
    .title {
        .title_ellipsis {
            img {
                width: 0.4rem;
            }
        }
    }

    .searchBtnBox {
        margin: 0 0.28rem;

        .confirmBtn.borderRound {
            background: #fff !important;
            border: 1px solid #f86fab !important;
            color: #f86fab;
        }
    }

    .exchangeData {

        .tableTitle {
            text-align: left;
            padding: 0 0.28rem;
            height: 0.88rem;
            line-height: 0.88rem;
            color: #333;
            font-weight: 500;
            background-color: #fff;
            font-size: 0.32rem;
        }

        .tableItemBox {
            background-color: #fff;

            &:nth-child(odd) {
                background-color: #F9F9F9;
            }

            &:first-child {
                border-bottom: none;
            }

            .tableItemMore {
                text-align: left;
                padding: 0 0.28rem 0.4rem;

                p {
                    margin-top: 0.28rem;
                }
            }
        }
        .tableItem {
            border-bottom: 1px solid #EBEFF1;
            padding: 0 0.28rem;
            height: 0.88rem;
            color: #626872;

            &.tableHead {
                color: #333;
                background-color: #E5E5E5 !important;
            }

            div {
                flex: 1;
                text-align: left;
                font-size: 0.24rem;

                i {
                    color: #788597;
                    margin-left: 0.1rem;
                }
            }
        }
    }

    .customizeBtnBox {
      display: -webkit-box; /* Chrome 4+, Safari 3.1, iOS Safari 3.2+ */
      display: -moz-box; /* Firefox 17- */
      display: -webkit-flex; /* Chrome 21+, Safari 6.1+, iOS Safari 7+, Opera 15/16 */
      display: -moz-flex; /* Firefox 18+ */
      display: -ms-flexbox; /* IE 10 */
      display: flex; /* Chrome 29+, Firefox 22+, IE 11+, Opera 12.1/17/18, Android 4.4+ */

      div {
        width: 50%;
        height: 0.9rem;
        line-height: .9rem;
        text-align: center;
        font-size: .32rem;
      }

      .customizeBtnCancel {
        color: #F74995;
        background-color: #fff;
      }

      .customizeBtnConfirm {
        background-color: #F74995;
        color: #fff;
      }
    }
}

.bankListCont {
    margin-bottom: 0.3rem;
    min-height: 6rem;

    .bankListCont_item {
        padding: 0.36rem 0;
        margin: 0 0.28rem;
        border-bottom: 1px solid #EBEFF1;

        &:last-child {
            border-color: transparent;
        }

        .bankListCont_item_left {
            text-align: left;
            color: #626872;
            font-size: 0.2rem;

            img {
                width: 0.64rem;
                height: 0.64rem;
                margin-right: 0.1rem;
            }

            p:first-child {
                font-size: 0.28rem;
                color: #333;
                font-weight: bold;
                margin-bottom: 0.05rem;
            }
        }
    }
}
</style>

<style lang="scss">
.SubAgentReport {
    .searchBox {
        background-color: #fff;
        padding-bottom: 0.2rem;
        box-shadow: 0 0.04rem 0.08rem 0 rgba(0, 0, 0, 0.03);

        .confirmBtn {
            margin: 0 auto;
            width: calc(50% - 0.2rem);
        }

        .van-cell-group {
            border: 1px solid #f2f2f2;
            margin-bottom: 0.2rem;
        }

        .tips {
            text-align: left;
            padding: 0.2rem 0.28rem;
            line-height: 0.5rem;
            color: #c4cacc;
        }
    }

    .betSearch {
        .van-dropdown-menu__bar {
            box-shadow: 0 0 0 0 rgb(0, 0, 0, 0) !important;
        }
        
        .van-dropdown-menu__title {
            width: 100%;
            padding: 0 !important;

            &:after {
                border-width: 0 !important;
            }
        }
    }
}
</style>